import React from "react";
import { useTheme } from "@mui/material";
import Button from "components/basic/button";

interface WizardButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  color: "primary" | "warning" | "success" | "error";
  loading?: boolean;
}

const WizardButton: React.FC<WizardButtonProps> = ({
  children,
  onClick,
  color,
  loading = false,
}) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      color={color}
      size="large"
      onClick={onClick}
      loading={loading}
      // Button always sets fontWeight inline, and inline beats sx, so the
      // weight has to stay here while the breakpoint-aware sizing goes in sx.
      style={{ color: theme.palette.common.white, fontWeight: "bold" }}
      sx={{
        // Share the row on a phone instead of stranding a narrow button.
        flex: { xs: "1 1 140px", sm: "0 0 auto" },
        fontSize: { xs: "1rem", sm: "1.2rem" },
        paddingX: { xs: 2, sm: 3.5 },
      }}
    >
      {children}
    </Button>
  );
};

export default WizardButton;
